import pako from "pako";

/**
 * Decodes the body of the live/analysis endpoints that used to be "pako-gzipped"
 * by the server (GetMachineActvityForLiveReport, GetCardViewDashboardForLiveView,
 * GetAndonViewDashboard, GetDownTimeAnalysis, GetQualityAnalysis, GetQualityReport).
 *
 * Why this exists
 * ---------------
 * The server did res.send(pako.gzip(...)). pako returns a Uint8Array, not a Node
 * Buffer, so Express serialised it as JSON: {"0":31,"1":139,...}. That is several
 * times larger than real gzip and often larger than the plain JSON. The server now
 * sends plain JSON and lets the compression middleware (br/gzip) handle the wire.
 *
 * This accepts both shapes so the UI works against old and new servers alike:
 *   - plain JSON (array/object)            -> returned as-is
 *   - {"0":31,"1":139,...} (old server)    -> ungzipped and parsed
 *   - ArrayBuffer / Uint8Array gzip bytes  -> ungzipped and parsed
 *   - string                               -> parsed
 */
const isGzipShaped = (data) =>
  data !== null &&
  typeof data === "object" &&
  !Array.isArray(data) &&
  data["0"] === 31 &&
  data["1"] === 139;

export function decodeJson(data) {
  if (data instanceof ArrayBuffer) data = new Uint8Array(data);
  if (data instanceof Uint8Array) {
    return JSON.parse(pako.ungzip(data, { to: "string" }));
  }
  if (isGzipShaped(data)) {
    return JSON.parse(pako.ungzip(Uint8Array.from(Object.values(data)), { to: "string" }));
  }
  if (typeof data === "string") {
    return data ? JSON.parse(data) : data;
  }
  return data;
}

export default decodeJson;
